import { usePlatformStore } from '@/shared/stores/platform'

export const formatNumber = (number: number | string) => {
  const platformStore = usePlatformStore()
  let locale = platformStore.locale

  try {
    new Intl.NumberFormat(locale)
  } catch (error) {
    locale = 'en-US'
  }

  return new Intl.NumberFormat(locale).format(Number(number || 0))
}
